<template>
  <div class="container-fluid">
    <div class="wrapper">
      <!-- Header -->
      <div class="header__logo">
        <div class="container">
          <a href="/" class="header__logo-link">
            <img
              class="header__logo-image"
              style=""
              src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132"
              alt="Aozama"
            />
          </a>
        </div>
      </div>

      <div class="create-offer-wrap">
        <div class="main-title">
          <h2>Crear nueva oferta</h2>
        </div>

        <!-- Create Offer Steps  -->
        <div class="section-splitter-wrap">
          <div class="section-splitter-indicators">
            <div
              class="section-item-indicator section-item-indicator-1 visited"
              @click="goTab(0)"
            >
              1
            </div>
            <div class="section-item-separator section-item-separator-1">
              <div class="separator-filler"></div>
            </div>
            <div
              class="section-item-indicator section-item-indicator-2"
              @click="goTab(1)"
            >
              2
            </div>
            <div class="section-item-separator section-item-separator-2">
              <div class="separator-filler"></div>
            </div>
            <div
              class="section-item-indicator section-item-indicator-2"
              @click="goTab(2)"
            >
              3
            </div>
          </div>

          <div class="section-splitter-texts">
            <div class="section-item-text section-item-text-1 visited">
              Descripción
            </div>
            <div class="section-item-text section-item-text-2">
              Detalle de Montos
            </div>
            <div class="section-item-text section-item-text-3">Finalizar</div>
          </div>
        </div>

        <div class="form-section-scroller">
          <!--  "no" means for "new offer" -->

          <!-- Content Stepe #1 -->
          <div class="no-section-wrap no-section-wrap-1">
            <!-- Imagen de oferta -->
            <div class="no-form-group file-upload">
              <div class="no-form-label">Imágen de Oferta</div>
              <input type="file" id="uploadImages" @change="uploadImages" />
              <div class="no-form-input">
                <label for="uploadImages" v-show="!loading">
                  <i class="fas fa-images"></i>
                  <span>Agregar imágenes</span>
                </label>
                <div class="loader" id="loader-7" v-show="loading"></div>
              </div>
              <div class="no-form-label">
                Su archivo debe estar en .jpg .png con menos de 2 MB de tamaño.
                <ul>
                  <li v-for="image in form.images">
                    <a href="{{image}}" target="_blanck">{{ image }}</a>
                    <button @click="deleteImages(image.id)">
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Titulo de oferta -->
            <div class="no-form-group">
              <div class="no-form-label">Título Oferta</div>
              <div class="no-form-input">
                <input
                  type="text"
                  placeholder="Nombre oferta"
                  v-model="form.title"
                />
              </div>
            </div>

            <!-- Tipos de ofertas -->
            <div class="row">
              <!-- Sección -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Sección</div>
                  <div class="no-form-input">
                    <select
                      v-model="form.service_type_id"
                      @change="eventChange()"
                    >
                      <option value="0">Seleccione un elemento</option>
                      <option
                        v-for="service in services"
                        v-bind:value="service.id"
                      >
                        {{ service.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Tipo de oferta -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Tipo de Oferta</div>
                  <div class="no-form-input">
                    <select v-model="form.type">
                      <option value="0">Producto</option>
                      <option value="1">Servicios</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tipos de Marcas y Modelos -->
            <div class="row">
              <!-- Marca -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Marcas</div>
                  <div class="no-form-input">
                    <select v-model="form.brand_id">
                      <option value="0">Seleccione un elemento</option>
                      <option v-for="brand in brands" v-bind:value="brand.id">
                        {{ brand.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Modelo -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Modelos</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      placeholder="Modelo"
                      v-model="form.model"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Categoria de oferta -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Categoria de Oferta</div>
                  <div class="no-form-input">
                    <select v-model="form.categories_id">
                      <option value="0">Seleccione un elemento</option>
                      <option
                        v-for="categoria in categories"
                        v-bind:value="categoria.id"
                      >
                        {{ categoria.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Proveedor -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Proveedor</div>
                  <div class="no-form-input">
                    <select v-model="form.provider_id">
                      <option value="0">Seleccione un elemento</option>
                      <option
                        v-for="provider in providers"
                        v-bind:value="provider.id"
                      >
                        {{ provider.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Categoria de oferta -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Es una oferta destacado?</div>
                  <div class="no-form-input">
                    <select v-model="form.top_offers">
                      <option value="0">No</option>
                      <option value="1">Si</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Categoria de oferta -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">En las mejores ofertas</div>
                  <div class="no-form-input">
                    <select v-model="form.promotion">
                      <option value="0">No</option>
                      <option value="1">Si</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Categoria de oferta -->
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Es una oferta destacado?</div>
                  <div class="no-form-input">
                    <select v-model="form.top_offers">
                      <option value="0">No</option>
                      <option value="1">Si</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="no-form-group">
              <div class="no-form-label">Descripción</div>
              <div class="no-form-input">
                <textarea
                  placeholder="Descripción aquí"
                  v-model="form.description"
                ></textarea>
              </div>
            </div>

            <div class="new-offer-buttons">
              <button
                class="new-offer-btn new-offer-btn-1"
                id="newOfferGrayBtn"
                @click="cancel()"
              >
                Cancelar
              </button>
              <button
                class="new-offer-btn new-offer-btn-success new-offer-btn-2"
                id="newOfferGreenBtn"
                @click="goTab(1)"
              >
                Siguiente
              </button>
            </div>
          </div>

          <!-- Content Stepe #2 -->
          <div class="no-section-wrap no-section-wrap-2">
            <div class="no-form-group">
              <div class="no-form-label">Días de oferta</div>
              <div class="no-form-input">
                <input
                  type="text"
                  v-model="form.days"
                  placeholder="Días de oferta"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Límite de cuotas</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      v-model="form.fee"
                      placeholder="Límite de cuotas"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Valor</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      v-model="form.amount"
                      placeholder="Valor"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Porcentaje de comisión</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      placeholder="Porcentaje de comisión"
                      v-model="form.comission_percent"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Porcentaje de descuento</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      placeholder="Porcentaje de descuento"
                      v-model="form.discount_percent"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Vigencia</div>
                  <div class="no-form-input">
                    <select v-model="form.validity">
                      <option value="0">Indefinida</option>
                      <option value="1">Temporaria</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Costo</div>
                  <div class="no-form-input">
                    <input
                      type="text"
                      placeholder="Costo"
                      v-model="form.cost"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="form.validity == 1">
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Fecha de inicio</div>
                  <div class="no-form-input">
                    <input
                      type="date"
                      placeholder="Fecha de inicio"
                      v-model="form.start_date"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="no-form-group">
                  <div class="no-form-label">Fecha de Vencimiento</div>
                  <div class="no-form-input">
                    <input
                      type="date"
                      placeholder="Fecha de inicio"
                      v-model="form.due_date"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="new-offer-buttons">
              <button
                class="new-offer-btn new-offer-btn-1"
                id="newOfferGrayBtn"
                @click="goTab(0)"
              >
                Volver atrás
              </button>
              <button
                class="new-offer-btn new-offer-btn-success new-offer-btn-2"
                id="newOfferGreenBtn"
                @click="goTab(2)"
              >
                Siguiente
              </button>
            </div>
          </div>

          <!-- Content Stepe #3 -->
          <div class="no-section-wrap no-section-wrap-3">
            <!-- Vista previa de oferta -->
            <div class="no-product-wrap">
              <h3>Preview Oferta</h3>
              <div class="no-product-title">
                <h2>{{ form.title }}</h2>
              </div>
              <gallery :images="productImages"></gallery>
              <div class="no-product-main-features"></div>
              <div class="no-product-long-description">
                <p>
                  {{ form.description }}
                </p>
              </div>
            </div>

            <!-- Buttons steps -->
            <div class="new-offer-buttons">
              <button
                class="new-offer-btn new-offer-btn-1"
                id="newOfferGrayBtn"
                @click="goTab(1)"
              >
                Volver atrás
              </button>

              <button
                class="new-offer-btn new-offer-btn-success new-offer-btn-2"
                id="newOfferGreenBtn"
                @click="created()"
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gallery from "../utilities/regular-gallery.vue";

export default {
  name: "create-offer",
  components: { gallery },
  data: () => {
    return {
      productImages: [],
      loading: false,
      form: {
        provider_id: 0,
        categories_id: 0,
        title: "",
        type_id: 1,
        service_type_id: 0,
        brand_id: 0,
        description: "",
        fee: "",
        days: "",
        amount: "",
        comission_percent: "",
        model: "",
        cost: "",
        start_date: "",
        due_date: "",
        validity: 0,
        intern: 1,
        type: 0,
        top_offers: 0,
        promotion: 0,
        imagesIds: [],
      },
      categories: [],
      providers: [],
      services: [],
      brands: [],
    };
  },
  async created() {
    this.getProviders();
    this.getServices();
    this.getbrands();
  },
  methods: {
    uploadImages: function (val) {
      this.loading = true;
      let imageData = new FormData();
      imageData.append("image", val.target.files[0]);
      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + `/media`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: imageData,
      }).then(
        function (response) {
          var path = "https://api.cashdepotint.com/" + response.data.path;
          swal("¡Listo!", "La imagan se agrego exitosamente.", "success");
          this.productImages.push(path);
          this.form.imagesIds.push(response.data.id);
          this.loading = false;
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "¡Ha ocurrido un error al actualizar la imagen! " +
              response.status.message,
            "error"
          );
          this.loading = false;
          this.creatingUpdatingOffer = false;
        }
      );
    },
  eventChange() {
    this.searchCategories();
    this.getbrands();
  },
    deleteImages(id) {
      if (confirm("Quieres eliminar esta imagen?")) {
        this.$http.delete(apiUrl + "/media/" + id).then((response) => {
          this.form.images = this.form.images.map(function (x, id) {
            return id == x.id;
          });
        });
      }
    },
    goTab: function (tab) {
      let scrollerItemsBase = document.querySelector(
        ".no-section-wrap.no-section-wrap-1"
      );
      let indicators = document.querySelectorAll(".section-item-indicator");

      scrollerItemsBase.style.marginLeft = `calc(-100% * ${tab})`;

      indicators.forEach((indicator, i) => {
        if (tab > i) indicator.classList.add("passed");

        if (tab == i) {
          indicator.classList.add("visited");
          indicator.classList.remove("passed");
        }

        if (tab < i) {
          indicator.classList.remove("visited");
          indicator.classList.remove("passed");
        }
      });
    },
    searchCategories() {
      this.$http
        .get(
          apiUrl +
            `/categories?q=(service_type_id:${this.form.service_type_id})&sort=position_order|asc`
        )
        .then((response) => {
          this.categories = response.data;
        });
    },
    getProviders() {
      this.$http.get(apiUrl + "/providers").then((response) => {
        this.providers = response.data;
      });
    },
    getServices() {
      this.$http.get(apiUrl + "/service-types").then((response) => {
        this.services = response.data;
      });
    },
    getbrands() {
      if (this.form.service_type_id == 5 || this.form.service_type_id == '5') {
        this.$http.get(apiUrl + `/brands?q=(service_type_id:${this.form.service_type_id})&sort=position_order|asc`).then((response) => {
          this.brands = response.data;
        });
      } else {
        this.$http.get(apiUrl + "/brands").then((response) => {
          this.brands = response.data;
        });
      }
    },
    created() {
      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + "/offers",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: this.form,
      }).then(
        function (response) {
          sweetAlert("Success", "Registro creado exitosamente !", "success");
          window.location.href = "/#!/administrator/offers";
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "¡Ha ocurrido un error! " + response.data.status.message,
            "error"
          );
        }
      );
    },
    cancel() {
      window.location = "/#!/administrator/offers";
    },
  },
};
</script>

<style scoped>
a {
  border: none;
}
.container-fluid {
  padding: 0px;
}

/* Header */
.header__logo {
  background-color: #1e2d7d;
  max-height: 90px;
}
.header__logo a {
  display: block;
}

.header__logo-image {
  width: 180px;
}

.create-offer-wrap {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
}

.create-offer-wrap * {
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
.create-offer-wrap .main-title {
  text-align: center;
}

.create-offer-wrap .main-title > h2,
.no-product-title h2 {
  font-weight: 800;
}

.section-splitter-indicators {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-item-indicator {
  display: inherit;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: #fff;
  color: #ebebeb;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  border: 1px solid #ebebeb;
  cursor: pointer;
}

.section-item-indicator.visited {
  background-color: #213f99;
}

.section-item-indicator.passed + .section-item-separator .separator-filler {
  width: 100%;
}

.section-item-separator {
  height: 2px;
  width: 120px;
  background-color: #ebebeb;
}

.section-item-separator .separator-filler {
  background-color: #213f99;
  width: 0%;
  height: 100%;
}

.section-splitter-texts {
  display: flex;
  font-size: 12px;
  margin-top: 5px;
  justify-content: center;
}

.section-item-text {
  width: 162px;
  text-align: center;
  color: #888;
}

.section-item-text.visited {
  color: #213f99;
}

.form-section-scroller {
  margin-top: 40px;
  margin-bottom: 25px;
  display: flex;
  overflow-x: hidden;
}

.form-section-scroller > div {
  min-width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}

.no-form-label {
  font-size: 12px;
  margin-bottom: 7px;
  text-align: left;
}

.no-form-input {
  display: flex;
  margin-bottom: 20px;
}

.no-form-input input,
.no-form-input select,
.no-form-input textarea,
.no-form-input label {
  border: 1px solid #eaeaea;
  background-color: #fff;
  padding: 14px 20px;
  width: 100%;
  font-size: 12px;
  border-radius: 0;
}

.no-form-input input::-webkit-input-placeholder,
.no-form-input textarea::-webkit-input-placeholder {
  color: #888;
}

.no-form-input select {
  color: #888;
}

.no-form-input select > option:not(:first-of-type) {
  color: #000;
}

.no-form-input textarea {
  min-height: 100px;
}

.file-upload {
  margin-bottom: 50px;
}

.file-upload input[type="file"] {
  display: none;
}

.file-upload label {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: #888;
  flex-flow: column;
}

.file-upload label i {
  font-size: 40px;
  opacity: 0.5;
  margin-bottom: 5px;
}

.file-upload .no-form-input {
  margin-bottom: 8px;
}

.file-upload .no-form-label {
  color: #888;
  text-align: center;
}

.new-offer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  flex: 1;
  align-items: flex-end;
}

.new-offer-buttons button {
  border-radius: 5px;
  border: 0;
  padding: 15px;
  width: 47%;
  min-width: 100px;
  background-color: #6c6c6c;
  color: #fff;
  text-transform: uppercase;
  font-weight: 800;
  cursor: pointer;
}

.new-offer-buttons button:focus {
  outline: none;
}

.new-offer-btn-success {
  background-color: #38b449 !important;
}

.no-product-wrap {
  max-width: 500px;
  margin: 0 auto;
}

.no-product-wrap > h3 {
  font-weight: lighter;
  color: #ccc;
}

/* Temporal row style emulation */

/* .row {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.row .col-lg-6 {
  width: 47%;
} */

a {
  text-decoration: none;
}

.main-wrap {
  background: #000;
  text-align: center;
}
.main-wrap h1 {
  color: #fff;
  margin-top: 50px;
  margin-bottom: 100px;
}
.col-md-3 {
  display: block;
  float: left;
  margin: 1% 0 1% 1.6%;
  background-color: #eee;
  padding: 50px 0;
}

.col:first-of-type {
  margin-left: 0;
}

/* ALL LOADERS */

.loader {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: relative;
  margin: 0 auto;
}

/* LOADER 1 */

#loader-1:before,
#loader-1:after {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: 10px solid transparent;
  border-top-color: #38b449;
}

#loader-1:before {
  z-index: 100;
  animation: spin 1s infinite;
}

#loader-1:after {
  border: 10px solid #ccc;
}

@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

/* LOADER 2 */

#loader-2 span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #38b449;
  margin: 35px 5px;
}

#loader-2 span:nth-child(1) {
  animation: bounce 1s ease-in-out infinite;
}

#loader-2 span:nth-child(2) {
  animation: bounce 1s ease-in-out 0.33s infinite;
}

#loader-2 span:nth-child(3) {
  animation: bounce 1s ease-in-out 0.66s infinite;
}

@keyframes bounce {
  0%,
  75%,
  100% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
  }

  25% {
    -webkit-transform: translateY(-20px);
    -ms-transform: translateY(-20px);
    -o-transform: translateY(-20px);
    transform: translateY(-20px);
  }
}

/* LOADER 3 */

#loader-3:before,
#loader-3:after {
  content: "";
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  left: calc(50% - 10px);
  background-color: #38b449;
  animation: squaremove 1s ease-in-out infinite;
}

#loader-3:after {
  bottom: 0;
  animation-delay: 0.5s;
}

@keyframes squaremove {
  0%,
  100% {
    -webkit-transform: translate(0, 0) rotate(0);
    -ms-transform: translate(0, 0) rotate(0);
    -o-transform: translate(0, 0) rotate(0);
    transform: translate(0, 0) rotate(0);
  }

  25% {
    -webkit-transform: translate(40px, 40px) rotate(45deg);
    -ms-transform: translate(40px, 40px) rotate(45deg);
    -o-transform: translate(40px, 40px) rotate(45deg);
    transform: translate(40px, 40px) rotate(45deg);
  }

  50% {
    -webkit-transform: translate(0px, 80px) rotate(0deg);
    -ms-transform: translate(0px, 80px) rotate(0deg);
    -o-transform: translate(0px, 80px) rotate(0deg);
    transform: translate(0px, 80px) rotate(0deg);
  }

  75% {
    -webkit-transform: translate(-40px, 40px) rotate(45deg);
    -ms-transform: translate(-40px, 40px) rotate(45deg);
    -o-transform: translate(-40px, 40px) rotate(45deg);
    transform: translate(-40px, 40px) rotate(45deg);
  }
}

/* LOADER 4 */

#loader-4 span {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background-color: #38b449;
  margin: 35px 5px;
  opacity: 0;
}

#loader-4 span:nth-child(1) {
  animation: opacitychange 1s ease-in-out infinite;
}

#loader-4 span:nth-child(2) {
  animation: opacitychange 1s ease-in-out 0.33s infinite;
}

#loader-4 span:nth-child(3) {
  animation: opacitychange 1s ease-in-out 0.66s infinite;
}

@keyframes opacitychange {
  0%,
  100% {
    opacity: 0;
  }

  60% {
    opacity: 1;
  }
}

/* LOADER 5 */

#loader-5 span {
  display: block;
  position: absolute;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  width: 20px;
  height: 20px;
  background-color: #38b449;
}

#loader-5 span:nth-child(2) {
  animation: moveanimation1 1s ease-in-out infinite;
}

#loader-5 span:nth-child(3) {
  animation: moveanimation2 1s ease-in-out infinite;
}

#loader-5 span:nth-child(4) {
  animation: moveanimation3 1s ease-in-out infinite;
}

@keyframes moveanimation1 {
  0%,
  100% {
    -webkit-transform: translateX(0px);
    -ms-transform: translateX(0px);
    -o-transform: translateX(0px);
    transform: translateX(0px);
  }

  75% {
    -webkit-transform: translateX(30px);
    -ms-transform: translateX(30px);
    -o-transform: translateX(30px);
    transform: translateX(30px);
  }
}

@keyframes moveanimation2 {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }

  75% {
    -webkit-transform: translateY(30px);
    -ms-transform: translateY(30px);
    -o-transform: translateY(30px);
    transform: translateY(30px);
  }
}

@keyframes moveanimation3 {
  0%,
  100% {
    -webkit-transform: translate(0px, 0px);
    -ms-transform: translate(0px, 0px);
    -o-transform: translate(0px, 0px);
    transform: translate(0px, 0px);
  }

  75% {
    -webkit-transform: translate(30px, 30px);
    -ms-transform: translate(30px, 30px);
    -o-transform: translate(30px, 30px);
    transform: translate(30px, 30px);
  }
}

/* LOADER 6 */

#loader-6 {
  top: 40px;
  left: -2.5px;
}

#loader-6 span {
  display: inline-block;
  width: 5px;
  height: 20px;
  background-color: #38b449;
}

#loader-6 span:nth-child(1) {
  animation: grow 1s ease-in-out infinite;
}

#loader-6 span:nth-child(2) {
  animation: grow 1s ease-in-out 0.15s infinite;
}

#loader-6 span:nth-child(3) {
  animation: grow 1s ease-in-out 0.3s infinite;
}

#loader-6 span:nth-child(4) {
  animation: grow 1s ease-in-out 0.45s infinite;
}

@keyframes grow {
  0%,
  100% {
    -webkit-transform: scaleY(1);
    -ms-transform: scaleY(1);
    -o-transform: scaleY(1);
    transform: scaleY(1);
  }

  50% {
    -webkit-transform: scaleY(1.8);
    -ms-transform: scaleY(1.8);
    -o-transform: scaleY(1.8);
    transform: scaleY(1.8);
  }
}

/* LOADER 7 */

#loader-7 {
  -webkit-perspective: 120px;
  -moz-perspective: 120px;
  -ms-perspective: 120px;
  perspective: 120px;
}

#loader-7:before {
  content: "";
  position: absolute;
  left: 25px;
  top: 25px;
  width: 50px;
  height: 50px;
  background-color: #38b449;
  animation: flip 1s infinite;
}

@keyframes flip {
  0% {
    transform: rotate(0);
  }

  50% {
    transform: rotateY(180deg);
  }

  100% {
    transform: rotateY(180deg) rotateX(180deg);
  }
}

/* LOADER 8 */

#loader-8:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  top: calc(50% - 10px);
  left: 0px;
  background-color: #38b449;
  animation: rotatemove 1s infinite;
}

@keyframes rotatemove {
  0% {
    -webkit-transform: scale(1) translateX(0px);
    -ms-transform: scale(1) translateX(0px);
    -o-transform: scale(1) translateX(0px);
    transform: scale(1) translateX(0px);
  }

  100% {
    -webkit-transform: scale(2) translateX(45px);
    -ms-transform: scale(2) translateX(45px);
    -o-transform: scale(2) translateX(45px);
    transform: scale(2) translateX(45px);
  }
}
</style>



// WEBPACK FOOTER //
// create-offer.vue?11dc74f8